
import React from "react";
import ResultLayout from "./ResultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { ResultIcon, KeyValueRow } from "./components";

export default function RefundFail() {
  const nav = useNavigate();
  const { search } = useLocation();
  const q = new URLSearchParams(search);

  const orderId   = q.get("orderId");
  const tid       = q.get("tid");
  const resultCode= q.get("resultCode");
  const resultMsg = q.get("resultMsg");

  return (
    <ResultLayout title="환불 실패">
      <div className="contents-wrap">
        <div className="text-cent" style={{padding:'24px 0 8px'}}>
          <ResultIcon type="refund-fail" />
          <h3 style={{marginBottom:4}}>환불 요청이 실패했습니다.</h3>
          <p className="sub-txt">{resultMsg || "사유를 확인 후 다시 시도하거나 관리자에게 문의하세요."}</p>
        </div>

        <div className="lineTop_tb01 mt18">
          <table className="lineTop_tb2">
            <tbody>
              <KeyValueRow label="주문번호" value={orderId} />
              <KeyValueRow label="거래번호(TID)" value={tid} />
              <KeyValueRow label="결과코드" value={resultCode} />
              <KeyValueRow label="결과메시지" value={resultMsg} />
            </tbody>
          </table>
        </div>

        <div className="btn-wrap text-cent mt30">
          <button className="btn btn-blue" onClick={() => nav(-1)}>다시 시도</button>
          <button className="btn btn-gray ml10" onClick={() => nav("/")}>홈으로</button>
        </div>
      </div>
    </ResultLayout>
  );
}
